import { Component, Input } from '@angular/core'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatMenuModule } from '@angular/material/menu'
import {
  LanguageIconComponent,
  SharedHamburgerMenuComponent,
  ThemeIconComponent,
} from 'shared-components'
import { LeaveGamePlayComponent } from '../leave-game-play/leave-game-play.component'

@Component({
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    SharedHamburgerMenuComponent,
    LanguageIconComponent,
    ThemeIconComponent,
    LeaveGamePlayComponent,
  ],
  selector: 'sans-play-hamburger-menu',
  templateUrl: './play-hamburger-menu.component.html',
  styleUrls: ['./play-hamburger-menu.component.scss'],
})
export class PlayHamburgerMenuComponent {
  @Input() public gamePlayId = ''
}
